import clsx from 'clsx'
import { WithChildren } from '@/root/types/utilities'

export type TTabUISize = 'lg'

export function TabUI({
  children,
  isActive,
  size,
  theme = 'chip',
  onClick,
}: WithChildren<{
  isActive?: boolean
  size?: TTabUISize
  theme?: 'chip' | 'onlyColor' | 'chip-inactive-bg-white'
  onClick?: () => void
}>) {
  let className = ''
  const commonClassName = 'cursor-pointer'

  const fontSizeClass = clsx('text-13px', {
    '!text-base': size === 'lg' || theme === 'onlyColor',
  })

  if (theme === 'chip' || theme === 'chip-inactive-bg-white') {
    className = clsx('px-2.5 py-2 rounded-lg', fontSizeClass, {
      'bg-chart-blue text-white': isActive,
      'bg-grey-tertiary text-grey': !isActive,
      '!bg-ind-white shadow-one':
        theme === 'chip-inactive-bg-white' && !isActive,
    })
  }

  if (theme === 'onlyColor') {
    className = clsx('p-2', fontSizeClass, {
      'text-ind-black': !isActive,
      'text-ind-blue border-b-2 border-ind-blue': isActive,
    })
  }

  return (
    <div className={clsx(className, commonClassName)} onClick={onClick}>
      {children}
    </div>
  )
}
